import React, { useEffect, useState } from "react";
import { app } from "../../Firebase/Firebaseapp";
import { doc, getFirestore, getDoc, updateDoc } from "firebase/firestore";
import { useDispatch, useSelector } from "react-redux";
import { UpdateDependency } from "../../Redux/Slice/AutSlice";


const Firestore = getFirestore(app);

const UpdateForm = ({ details, carsId, modal }) => {
  const { user } = useSelector((state) => state.FirebaseAuth);
  const dispatch = useDispatch();

  const [carInfo, setCarInfo] = useState({});


  useEffect(() => {
    console.log("update form");
    console.log(carsId);
    setCarInfo(details);
   
  }, []);

  const updateData = async () => {
    const userRef = doc(Firestore, "CarDetails", carsId);
    await updateDoc(userRef, {
      Name: carInfo.Name,
      Description: carInfo.Description,
      DrivingRange: carInfo.DrivingRange,
      Power: carInfo.Power,
      Transmission: carInfo.Transmission,
      BatteryCapacity: carInfo.BatteryCapacity,
      MaxPower: carInfo.MaxPower,
      MaxTorque: carInfo.MaxTorque,
      SeatingCapacity: carInfo.SeatingCapacity,
      BodyType: carInfo.BodyType,
      Price: carInfo.Price,
      userEmail: user,
      
    });
  };

  const handelChange = (e) => {
    const { name, value } = e.target;
    setCarInfo((oldValue) => {
      return {
        ...oldValue,
        [name]: value,
      };
    });
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    updateData();
    modal(false);
    dispatch(UpdateDependency())
  };

  return (
    <div>
      <section className="w-[95%] sm:w-[100%] p-10 mx-auto backdrop-blur-sm bg-black/50 absolute top-0">
        <h1 className="text-xl font-bold text-white capitalize dark:text-white text-center">
          Add New Car
        </h1>
        <form onSubmit={onFormSubmit}>
          <div className="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
            <div>
              <label className="text-white dark:text-gray-200">car Name</label>
              <input
                id="username"
                type="text"
                placeholder="Car Name..."
                name="Name"
                value={carInfo.Name || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>

            <div>
              <label className="text-white dark:text-gray-200">
                Driving Range
              </label>
              <input
                id="emailAddress"
                placeholder="Driving Range"
                type="text"
                name="DrivingRange"
                value={carInfo.DrivingRange || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>

            <div>
              <label className="text-white dark:text-gray-200">Power</label>
              <input
                placeholder="Power"
                type="text"
                id="email"
                name="Power"
                value={carInfo.Power || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>

            <div>
              <label className="text-white dark:text-gray-200">
                Transmission
              </label>
              <input
                placeholder="Transmission"
                type="text"
                id="phone"
                name="Transmission"
                value={carInfo.Transmission || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>
            <div>
              <label className="text-white dark:text-gray-200">
                Battery Capacity
              </label>
              <input
                placeholder="Battery Capacity"
                type="number"
                id="email"
                name="BatteryCapacity"
                value={carInfo.BatteryCapacity || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>
            <div>
              <label className="text-white dark:text-gray-200">
                Seating Capacity
              </label>
              <input
                placeholder="Seating Capacity"
                type="Text"
                id="phone"
                name="SeatingCapacity"
                value={carInfo.SeatingCapacity || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>
            <div>
              <label className="text-white dark:text-gray-200">Max-Power</label>
              <input
                placeholder="Max-Power"
                type="text"
                id="phone"
                name="MaxPower"
                value={carInfo.MaxPower || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>
            <div>
              <label className="text-white dark:text-gray-200">
                Max-Torque
              </label>
              <input
                placeholder="Max-Torque"
                type="text"
                id="email"
                name="MaxTorque"
                value={carInfo.MaxTorque || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>

            <div>
              <label className="text-white dark:text-gray-200">Body Type</label>
              <input
                placeholder="Body Type"
                type="text"
                id="phone"
                name="BodyType"
                value={carInfo.BodyType || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>

            <div>
              <label className="text-white dark:text-gray-200">Price</label>
              <input
                placeholder="Price"
                type="text"
                id="phone"
                name="Price"
                value={carInfo.Price || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                required
              />
            </div>

            <div>
              <label className="text-white dark:text-gray-200">
                Car Description
              </label>
              <textarea
                placeholder="Car Description..."
                type="textarea"
                id="email"
                name="Description"
                value={carInfo.Description || ""}
                onChange={handelChange}
                className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
              ></textarea>
            </div>
            <div>
              <label className="block text-sm font-medium text-white">
                Image
              </label>
             
            </div>
          </div>

          <div className="flex justify-center mt-6 mb-2">
            <button
              type="submit"
              className="w-[300px] h-[40px] mx-2 leading-5 text-white transition-colors duration-200 transform bg-pink-500 rounded-md hover:bg-pink-700 focus:outline-none focus:bg-gray-600"
            >
              Submit
            </button>

            <button
              type="submit" className="w-[300px] mx-2 h-[40px] leading-5 text-white transition-colors duration-200 transform bg-green-500 rounded-md hover:bg-red-600 focus:outline-none focus:bg-gray-600"
              onClick={()=>modal(false)}
              >
             
              Cancel
            </button>

          </div>

     
        </form>
      </section>
    </div>
  );
};

export default UpdateForm;
